module.exports = __webpack_public_path__ + "static/img/data2.4de96b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data2.png
// module id = RXjx
// module chunks = 13